// extracted by mini-css-extract-plugin
export default {"vertlist":"VerticalList_vertlist__rS71t"};